export default {
    modalShowImageVariations: {
        imageAi: 'Image AI',
        regenerateImage: 'Générer du nouveau contenu',
        description: 'Description :',
        style: 'Style:',
        saveToLibrary: 'Save to Library',
        continue: 'Continuer',
        cancel: 'Annuler',
        select: 'Select',
        copy: 'Copier',
    },
};
